import OrganizationCategoryAddPage from './OrganizationCategoryAddPage';

export default OrganizationCategoryAddPage;
